import { render, staticRenderFns } from "./grievance.vue?vue&type=template&id=07b841bd&scoped=true&"
import script from "./grievance.vue?vue&type=script&lang=js&"
export * from "./grievance.vue?vue&type=script&lang=js&"
import style0 from "./grievance.vue?vue&type=style&index=0&id=07b841bd&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07b841bd",
  null
  
)

export default component.exports